import React, {useState, useEffect} from "react";
import {Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";


import {Link} from "react-router-dom";
import AuthService from "../login/AuthService";
import ApiService from "../util/ApiService";
import locale from "antd/es/date-picker/locale/pt_BR";
import Skeleton from "react-loading-skeleton";
import Select from "react-select";
import "react-loading-skeleton/dist/skeleton.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Unauthorized = () => {
    document.title = "Não Autorizado | Plantão Rápido";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Não Autorizado" pageTitle="Erro"/>
                    <Row>
                        <div className="page-wrapper">
                            <div className="error-page mt-5">
                                <div className="main-wrapper">
                                    <div className="error-box">
                                        <h1>Ops!</h1>
                                        <h5 className="h2 mb-3">
                                            <i className="fa fa-warning"/> Você não tem permissão para acessar esta
                                            página.
                                        </h5>
                                        <p className="h6 font-weight-normal">
                                            Não se preocupe, pode ser apenas um pequeno engano. Caso precise de acesso,
                                            entre em
                                            contato com o suporte ou tente outra página!
                                        </p>
                                        <Link to="/admin" className="btn btn-primary">
                                            Voltar para o Início
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Unauthorized;
